<template>
    <span>
        <router-link
            v-if="
                useRouter &&
                contact.encoded_id &&
                (contact.type === 'business' || type === 'business')
            "
            :to="{
                name: 'contact_company',
                params: { id: contact.encoded_id }
            }"
        >
            {{ displayName }}
        </router-link>
        <router-link
            v-else-if="
                useRouter &&
                contact.encoded_id &&
                (contact.type !== 'business' || type !== 'business')
            "
            :to="{ name: 'contact_actor', params: { id: contact.encoded_id } }"
        >
            {{ displayName }}
        </router-link>
        <a v-else-if="contact.encoded_id" :href="contactUrl">
            {{ displayName }}
        </a>
        <span v-else> {{ displayName }} </span>
        <input
            type="hidden"
            name="contact-id"
            :value="contact.id ? contact.id : ''"
        />
    </span>
</template>

<script>
export default {
    name: "contactName",
    props: {
        contact: {
            type: Object,
            required: true
        },
        /**
         * type: business OR actor
         */
        type: {
            type: String,
            required: true
        },
        /**
         * text: label shown. if not specified, computed name will be used
         */
        text: {
            type: String,
            default: null
        },
        /**
         * useRouter: true = use react router push, false = use native anchor href
         */
        useRouter: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        contactUrl() {
            return this.type == "actor"
                ? "../view/contact/profile/" + this.contact.encoded_id
                : "../view/contact/company/" + this.contact.encoded_id;
        },
        displayName() {
            return this.text
                ? this.text
                : this.type == "actor"
                ? (this.contact.firstname || this.contact.first_name) +
                  " " +
                  (this.contact.lastname || this.contact.last_name)
                : this.contact.name;
        }
    },
    methods: {}
};
</script>
